import { useState } from "react";
import Card from "../components/ui/Card";
import { useAuth } from "../auth/AuthContext";
import { authService } from "../services/auth.service";
import { validationErrors } from "../services/http";

const inputClass =
  "w-full rounded-md border border-line/60 bg-surface-raised/60 px-3 py-2 text-sm outline-none focus:border-brand";

export default function ProfilePage() {
  const { user, setUser } = useAuth();
  const [name, setName] = useState(user?.name ?? "");
  const [email, setEmail] = useState(user?.email ?? "");
  const [profileMessage, setProfileMessage] = useState<string | null>(null);

  const [currentPassword, setCurrentPassword] = useState("");
  const [password, setPassword] = useState("");
  const [confirmation, setConfirmation] = useState("");
  const [passwordMessage, setPasswordMessage] = useState<string | null>(null);
  const [passwordError, setPasswordError] = useState<string | null>(null);

  async function saveProfile(event: React.FormEvent) {
    event.preventDefault();
    setProfileMessage(null);
    try {
      setUser(await authService.updateProfile({ name, email }));
      setProfileMessage("Dados atualizados.");
    } catch (err) {
      const fields = validationErrors(err);
      setProfileMessage(fields.email?.[0] ?? (err as Error).message);
    }
  }

  async function savePassword(event: React.FormEvent) {
    event.preventDefault();
    setPasswordMessage(null);
    setPasswordError(null);
    try {
      await authService.changePassword({
        current_password: currentPassword,
        password,
        password_confirmation: confirmation,
      });
      setPasswordMessage("Senha alterada.");
      setCurrentPassword("");
      setPassword("");
      setConfirmation("");
    } catch (err) {
      const fields = validationErrors(err);
      setPasswordError(
        fields.current_password?.[0] ?? fields.password?.[0] ?? (err as Error).message,
      );
    }
  }

  return (
    <div className="space-y-6">
      <h1 className="text-lg font-semibold tracking-wide">Meu perfil</h1>

      <Card title="Dados da conta">
        <form onSubmit={saveProfile} className="space-y-4">
          <label className="block">
            <span className="mb-1 block text-xs font-medium text-ink-muted">Nome</span>
            <input className={inputClass} value={name} onChange={(e) => setName(e.target.value)} required />
          </label>
          <label className="block">
            <span className="mb-1 block text-xs font-medium text-ink-muted">E-mail</span>
            <input
              className={inputClass}
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
            />
          </label>
          {profileMessage && <p className="text-sm text-ink-muted">{profileMessage}</p>}
          <button className="rounded-md bg-brand px-3 py-2 text-sm font-semibold text-brand-ink">
            Salvar
          </button>
        </form>
      </Card>

      <Card title="Alterar senha">
        <form onSubmit={savePassword} className="space-y-4">
          <label className="block">
            <span className="mb-1 block text-xs font-medium text-ink-muted">Senha atual</span>
            <input
              className={inputClass}
              type="password"
              autoComplete="current-password"
              value={currentPassword}
              onChange={(e) => setCurrentPassword(e.target.value)}
              required
            />
          </label>
          <label className="block">
            <span className="mb-1 block text-xs font-medium text-ink-muted">
              Nova senha (mínimo 10 caracteres, com letras e números)
            </span>
            <input
              className={inputClass}
              type="password"
              autoComplete="new-password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
            />
          </label>
          <label className="block">
            <span className="mb-1 block text-xs font-medium text-ink-muted">Confirmar nova senha</span>
            <input
              className={inputClass}
              type="password"
              autoComplete="new-password"
              value={confirmation}
              onChange={(e) => setConfirmation(e.target.value)}
              required
            />
          </label>
          {passwordMessage && <p className="text-sm text-emerald-400">{passwordMessage}</p>}
          {passwordError && <p className="text-sm text-red-400">{passwordError}</p>}
          <button className="rounded-md bg-brand px-3 py-2 text-sm font-semibold text-brand-ink">
            Alterar senha
          </button>
        </form>
      </Card>
    </div>
  );
}
